import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface FeedbackPayload {
  firstName: string;
  lastName: string;
  feedbackMessage: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackRepository {
  constructor(private http: HttpClient) {}

  postFeedback(payload: FeedbackPayload, token: string): Observable<HttpResponse<string>> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post(environment.feedbackEndPoint, payload, {
      headers,
      observe: 'response',
      responseType: 'text',
    }) as Observable<HttpResponse<string>>;
  }
}
